import React, { useContext } from 'react';

import BackupSummaryCharts from '@totem/components/services/backup/deviceBackups/backupSummary/backupSummaryCharts';
import BackupSummaryContext from '@totem/components/services/backup/deviceBackups/backupSummary/backupSummaryContext';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';

const ContinuitySection = () => {
  const { data } = useContext(BackupSummaryContext);

  const hasBackupSummary = typeof data !== 'undefined' && data !== null;

  const showContinuity = hasBackupSummary;

  return (
    <>
      {showContinuity && (
        <IBCard title={'Continuity'} isCovered>
          <BackupSummaryCharts />
        </IBCard>
      )}
    </>
  );
};

export default ContinuitySection;
